import { Model } from 'jms-domain'
import inRange from 'lodash-es/inRange.js'

import type { EntityDeletion } from '@salsita-ai/platform-project-sdk/domain'

import { configuratorInterface } from '../systems/configurator-interface.js'

/**
 * Remove a hood when a grill is deleted.
 */
export const removeHoodWithGrillTransformer = configuratorInterface.transformerBuilder.when
  .update(['deleteEntity'])
  .fired.and(ctx => Model.GrillBase.isId(ctx.update.entityId))
  .then.applySideEffect(ctx => {
    const $oldRoot = ctx.getOld$Root()

    const entityId = ctx.update.entityId as Model.BottomWallItem['id']
    const $entity = $oldRoot.$cabinets.find(c => c.id === entityId)
    if (!$entity) {
      return []
    }

    const $wall = $entity.$wall
    const $existingHoods = $wall.$topItems.filter(Model.Hood.is)
    if ($existingHoods.length === 0) {
      // There's no hood, nothing to do.
      return []
    }

    const $newRoot = ctx.getNew$Root()
    const updates: Array<EntityDeletion<Model.AnyDomainEntity>> = []

    for (const $hood of $existingHoods) {
      const exists = $newRoot.$appliances.some(a => a.id === $hood.id)
      if (!exists) {
        // Hood was deleted, nothing to do.
        continue
      }

      const isAbove = inRange($hood.x + $hood.$width / 2, $entity.x, $entity.x + $entity.$width)
      if (isAbove) {
        updates.push(
          configuratorInterface.updates.EntityDeletion({
            entityId: $hood.id,
            updateTag: 'removeHoodWithGrill',
          })
        )
      }
    }

    return updates
  })
  .build('Remove a hood when a grill is deleted')
